import {ReactNode} from "react";
import classNames from "classnames";
import {Svg} from "@/shared/ui/Svg";
import styles from "./ProductInformation.module.scss";

type Props = {
    title: ReactNode;
    opened: boolean;
    onToggle: () => void;
    children: ReactNode;
};

export const ProductInformationItem = (
    {
        title,
        opened,
        onToggle,
        children,
    }: Props
) => (
    <div className={styles.item}>
        <button type={`button`} className={styles.header} onClick={onToggle}>
            <p className={styles.title}>{title}</p>
            <Svg id={`arrowRight`} className={classNames(styles.arrow, {[styles.down]: opened})} />
        </button>
        <div className={classNames(styles.descriptionContainer, {[styles.visible]: opened})}>
            <div className={styles.description}>
                {children}
            </div>
        </div>
    </div>
);
